export default __webpack_public_path__ + "static/media/banner-111.88f2a37c.jpg";